import React from 'react';
import { connect } from 'react-redux';
import { RootState } from '../store';
import { Status } from '../models/networkStatus';

import styles from './NetworkStatusToast.module.css';

const NetworkStatusMessages: Record<Status, string> = {
  OFFLINE: 'No internet connection',
  UNREACHABLE: 'No connection, retrying...',
  ONLINE: 'Connected',
  CONNECTING: 'Connecting...',
};

const NetworkStatusColor: Record<Status, string> = {
  OFFLINE: '#ffbba2',
  UNREACHABLE: '#efd95b',
  ONLINE: '#bddbaf',
  CONNECTING: '#d3d3d3',
};

export function NetworkStatusToast({ networkStatus }: { networkStatus: Status }) {
  const text = NetworkStatusMessages[networkStatus];
  if (!text) return null;

  return (
    <div className={styles.container}>
      {networkStatus !== 'ONLINE' && (
        <div
          className={styles.textContainer}
          style={{
            background: NetworkStatusColor[networkStatus],
          }}
        >
          {text}
        </div>
      )}
    </div>
  );
}

const mapState = (state: RootState) => {
  return {
    networkStatus: state.networkStatus.status,
  };
};

export default connect(mapState)(NetworkStatusToast);
